import { parsePhoneNumber } from "libphonenumber-js";
import React from "react";

import { attemptMethod } from "@utils/general";

export type PhoneNumberProps = {
    phoneNumber?: string | null;
    ISOcountryCode?: string;
    asLink?: boolean;
};

const PhoneNumber = ({
    phoneNumber,
    ISOcountryCode = "",
    asLink = false,
}: PhoneNumberProps) => {
    if (!phoneNumber) return null;

    const parsedPhoneNumber = attemptMethod(
        () => {
            // @ts-ignore
            const phoneObject = parsePhoneNumber(phoneNumber, ISOcountryCode);
            return {
                label: phoneObject.formatInternational(),
                uri: phoneObject.getURI(),
            };
        },
        { label: phoneNumber, uri: `tel:${phoneNumber}` },
    );

    if (asLink) {
        return <a href={parsedPhoneNumber.uri}>{parsedPhoneNumber.label}</a>;
    }

    return <>{parsedPhoneNumber.label}</>;
};

export { PhoneNumber };
